module.exports = __webpack_public_path__ + "0ceb36b319a18b2cb2774e4b0de524ec.svg";